import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { useScrollReset } from "utils";
import Dotcontianer from "./Components/Dotcontianer";
import Herosection from "./Components/Herosection";
import Ninedotleftref from "./Components/Ninedotleftref";
import Ninedotrightref from "./Components/Ninedotrightref";
import Perfomancesolution from "./Components/Perfomancesolution";
import Secondrefcontainer from "./Components/Secondrefcontainer";
import Thirdrefcontainer from "./Components/Thirdrefcontainer";
import Whychoosesection from "./Components/Whychoosesection";
import MobileScreen from "./MobileScreen";
import usePageHook from "./usePageHook";

const LaptopsScreen = () => {
  const { mainDivContinerRef } = usePageHook();
  useScrollReset();

  return (
    <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}>
      <Helmet>
        <title>GridKey | Modern Wealth Management Platform</title>
        <meta
          name="description"
          content="GridKey is the command center for modern wealth management. Track multi-asset portfolios, manage clients, automate revenue, and empower smarter financial decisions."
        />
        <meta
          property="og:title"
          content="GridKey | Modern Wealth Management Platform"
        />
        <meta
          property="og:description"
          content="GridKey is the command center for modern wealth management. Track multi-asset portfolios, manage clients, automate revenue, and empower smarter financial decisions."
        />
        <meta property="og:url" content="https://gridkey.in/home" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://gridkey.in/home" />
      </Helmet>
      <div className="relative hidden lg:block">
        <div
          ref={mainDivContinerRef}
          className="relative w-screen h-screen overflow-hidden bg-black"
        >
          <Herosection />
          <Dotcontianer />
          <Ninedotleftref />
          <Ninedotrightref />
          <Perfomancesolution />
          <Whychoosesection />
          <Secondrefcontainer />
          <Thirdrefcontainer />
        </div>
      </div>
      <MobileScreen />
    </motion.div>
  );
};

export default LaptopsScreen;
